import { parseSchoolDateTime } from "shared/utils/dateHelpers";

export const toNumber = (value: unknown, fallback = 0): number => {
  return typeof value === "number" && !Number.isNaN(value) ? value : fallback;
};

/**
 * Parses an API date string into a JS Date, or null when absent/invalid.
 *
 * Naive values (no zone designator) are read as school wall-clock time -- see
 * {@link parseSchoolDateTime}, which is the single place that rule lives.
 */
export const toDate = (value?: string | null): Date | null =>
  parseSchoolDateTime(value);
